export const ROW_ACTIONS_FIELD = 'rowActions'
export const ROW_ACTIONS_TITLE = 'Row actions'
